import React from 'react';
import queryString from 'query-string';
import { Container } from '../../UI/Container/Container';
import { LrLogo } from '../../Icons/LrLogo';
import { PrismicHTMLParser } from '../../PrismicHTMLParser';
import { getRegistrationFormUrl } from '../../../helpers';
import './ResetPassword.scss';

type ResetPasswordProps = {
    location: Location;
    pageContext: {
        lang: string;
    };
    slice: {
        slice_type: 'reset_password';
        primary: {
            reset_password_title: { html: string };
        };
    };
};

class ResetPassword extends React.Component<ResetPasswordProps> {
    private iframeUrl: string | null;

    componentDidMount() {
        const redirectUrl = `${process.env.GATSBY_GUESTSITE_ENDPOINT}/login`;

        window.addEventListener('message', function(e) {
            const event = e.data;

            if (event.type === 'ResetPasswordSuccessful') {
                setTimeout(function() {
                    window.top.location.assign(redirectUrl);
                }, 1500);
            }
        });

        const params = queryString.parse(this.props.location.search);

        this.iframeUrl = getRegistrationFormUrl(
            this.props.pageContext.lang,
            { token: params.token },
            '/password/reset',
        );
    }

    render() {
        return (
            <Container className="ResetPassword" size="sm">
                <LrLogo />
                <PrismicHTMLParser className="ResetPassword-title">
                    {this.props.slice.primary.reset_password_title.html}
                </PrismicHTMLParser>

                {this.iframeUrl && (
                    <iframe src={this.iframeUrl} frameBorder="0" height="400" width="100%" />
                )}
            </Container>
        );
    }
}

export { ResetPassword, ResetPasswordProps };
